import fetch from "../utils/fetch";

//人工处理列表
export const fetchManualList = (params) =>
  fetch(`/try/handle/list`, {
    method: "get",
    params,
  });

//人工处理
export const fetchHandleManual = (data) =>
  fetch(`/try/handle`, {
    method: "post",
    data,
  });
